module.exports = __webpack_public_path__ + "media/images/last_page_horizontal_bg_lc-413ba34b697d0d706d8fab1b750e4de5.png";